import { Workflow } from 'lucide-react';
import { useMemo, type FC } from 'react';

interface EndpointEntry {
  endpoint: string;
  tokens: number;
  calls: number;
}

interface Props {
  topEndpoints: EndpointEntry[] | undefined;
}

const EndpointBreakdownList: FC<Props> = ({ topEndpoints }) => {
  const { items, total } = useMemo(() => {
    const sorted = [...(topEndpoints ?? [])].sort((a, b) => b.tokens - a.tokens);
    const sum = sorted.reduce((s, e) => s + e.tokens, 0) || 1;
    return { items: sorted.slice(0, 6), total: sum };
  }, [topEndpoints]);

  if (!items.length) return null;

  return (
    <div className="fc-card p-5">
      <div className="flex items-center gap-2">
        <Workflow className="h-4 w-4 text-slate-500 dark:text-slate-400" />
        <h3 className="text-xs font-medium uppercase tracking-wider text-slate-500 dark:text-slate-400">
          Top Endpoints Consommateurs
        </h3>
      </div>

      <div className="mt-4 space-y-3">
        {items.map((ep, idx) => {
          const pct = Math.round((ep.tokens / total) * 100);
          return (
            <div key={ep.endpoint}>
              <div className="flex items-center justify-between text-sm">
                <span className="font-mono text-xs text-slate-700 dark:text-slate-300">
                  {ep.endpoint}
                </span>
                <span className="text-slate-500 dark:text-slate-400">
                  {pct}% — {ep.tokens.toLocaleString('fr-FR')} tokens
                </span>
              </div>
              <div className="mt-1 h-2 w-full overflow-hidden rounded-full bg-slate-100 dark:bg-slate-700">
                <div
                  className={`h-full rounded-full transition-all duration-500 ${
                    idx === 0
                      ? 'bg-blue-500 dark:bg-blue-400'
                      : 'bg-slate-400 dark:bg-slate-500'
                  }`}
                  style={{ width: `${pct}%` }}
                />
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default EndpointBreakdownList;
